import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import { map } from 'rxjs/operators';
import { Navigate } from '@ngxs/router-plugin';

@Component({
  selector: 'lib-general-ledger-tile',
  templateUrl: './general-ledger-tile.component.html',
  styleUrls: ['./general-ledger-tile.component.css'],
  standalone: false
})
export class GeneralLedgerTileComponent implements OnInit {
  canDisplayTile: Observable<boolean>;

  constructor(public store: Store) {}

  ngOnInit() {
    this.canDisplayTile = this.store.select(ClientSelectionState.clientSetup).pipe(
      map(setup => {
        return setup.HasGeneralLedger;
      })
    );
  }

  clicked() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.store.dispatch(new Navigate([`/client/${code}/general-ledger`]));
    });
  }
}
